import {
    assetsTypes as contentTypes,
    defaultProfile,
    desktopKeyword,
    mobileKeyword,
} from '@/shared/constants/appConstants'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { persistStorage } from '@/shared/state/dataBase/persistStorage'
import Logo from '@/shared/assets/images/Logo.svg'
import assetsTypes from '../../types/assetsTypes/assetsTypes'
import { Skin, TermsAndConditions } from '@/types/ConfigProps'

export interface ProfileStreamIQ {
    iconId: string
    id: string
    isAdult: boolean
    order: string
    name: string
    version: number
    pin: number
    serviceName: string
    type: string
}

export interface Profile {
    iconId: string
    id: string
    isKid: boolean
    order: string
    profile_name: string
    version: number
    default?: boolean
    pin: number
}

export interface ProfileStreamIQ {
    iconId: string
    id: string
    isAdult: boolean
    order: string
    name: string
    version: number
    default?: boolean
    pin: number
    serviceName: string
    type: string
}

export interface AppStore {
    isCookiesAccepted: boolean
    isCacheChecked: boolean
    userEmail: string
    isUserLoggedIn: boolean
    previousPage: string
    appSkin: Skin | null
    profiles: Profile[]
    actualProfile: Profile | null
    device: string
    assetType: assetsTypes
    termsAndConditions: TermsAndConditions
    faq: string
    tAndC: string

    setIsUserLoggedIn: (isUserLoggedIn: boolean) => void
    setPreviousPage: (page: string) => void
    setAssetType: (type: assetsTypes) => void
    setAppSkin: (newSkin: Skin | null) => void
    setProfiles: (profiles: Profile[]) => void
    setTermsAndConditions: (termsAndConditions: TermsAndConditions) => void
    setActualProfile: (actualProfile: Profile) => void
    setFaq: (faq: string) => void
    setTAndC: (value: string) => void
    setEmail: (value: string) => void
    setIsCacheChecked: (value: boolean) => void
    setIsCookiesAccepted: (value: boolean) => void
    reset: () => void
}

export const useAppStore = create<AppStore>()(
    persist(
        (set) => ({
            isCacheChecked: false,
            isCookiesAccepted: false,
            userEmail: '',
            isUserLoggedIn: false,
            previousPage: '/',
            profiles: [],
            actualProfile: defaultProfile,
            device: navigator.userAgent.includes(mobileKeyword)
                ? mobileKeyword
                : desktopKeyword,
            assetType: contentTypes.TIVI,
            appSkin: {
                appLoginScreenLogoUrl: Logo,
                appMenuLogoUrl: Logo,
            },
            termsAndConditions: { isTermsAccepted: false, version: 0, url: '' },
            faq: '',
            tAndC: '',

            setIsUserLoggedIn: (isUserLoggedIn: boolean) =>
                set(() => ({
                    isUserLoggedIn,
                })),
            setPreviousPage: (page: string) =>
                set(() => ({
                    previousPage: page,
                })),
            setAssetType: (type: assetsTypes) =>
                set(() => ({
                    assetType: type,
                })),
            setAppSkin: (newSkin: Skin | null) =>
                set(() => ({
                    appSkin: newSkin,
                })),
            setProfiles: (profiles: Profile[]) =>
                set(() => ({
                    profiles,
                })),
            setTermsAndConditions: (termsAndConditions: TermsAndConditions) =>
                set(() => ({
                    termsAndConditions,
                })),
            setActualProfile: (actualProfile: Profile) =>
                set(() => ({
                    actualProfile,
                })),
            setFaq: (faq: string) =>
                set(() => ({
                    faq,
                })),
            setTAndC: (value: string) =>
                set(() => ({
                    tAndC: value,
                })),
            setEmail: (value: string) =>
                set(() => ({
                    userEmail: value,
                })),
            setIsCookiesAccepted: (value: boolean) =>
                set(() => ({
                    isCookiesAccepted: value,
                })),
            setIsCacheChecked: (value: boolean) =>
                set(() => ({
                    isCacheChecked: value,
                })),
            reset: () =>
                set(() => ({
                    isCacheChecked: false,
                    isCookiesAccepted: false,
                    userEmail: '',
                    isUserLoggedIn: false,
                    previousPage: '/',
                    profiles: [],
                    actualProfile: defaultProfile,
                    device: navigator.userAgent.includes(mobileKeyword)
                        ? mobileKeyword
                        : desktopKeyword,
                    assetType: contentTypes.TIVI,
                    appSkin: {
                        appLoginScreenLogoUrl: Logo,
                        appMenuLogoUrl: Logo,
                    },
                    termsAndConditions: {
                        isTermsAccepted: false,
                        version: 0,
                        url: '',
                    },
                    faq: '',
                    tAndC: '',
                })),
        }),
        {
            name: 'app-storage',
            storage: createJSONStorage(() => persistStorage),
        }
    )
)
